<template>
  <MonitorWrapper>
    <div class="mn-606-container" :class="{ 'is-mobile': isMobile }">
      <template v-if="!empty">
        <StatusBar v-bind="status" :model="model" :opts="opts" />
        <ChartWrap ref="chartWrap" :datas="charts" />
      </template>

      <template v-else>
        <div class="hint">{{ isHisDetail ? $t('暂无数据') : $t('数据加载中') }}</div>
      </template>
    </div>
  </MonitorWrapper>
</template>

<script>
import StatusBar from './components/status-bar.vue';
import ChartWrap from './components/wrap.vue';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';

import { isObject } from '@/utils/is';
import { useKeyLongPressEvent } from '@/utils/dom/event';

import { makeData } from './utils/faker';

export default {
  name: 'MN606',
  mixins: [singleDeviceMixin],
  components: {
    StatusBar,
    ChartWrap
  },
  provide() {
    return {
      time: this.time
    };
  },
  data() {
    return {
      status: {
        networkMode: 1,
        alarmStatus: -1,
        runState: 0
      },
      model: {
        humidity: '--',
        temperature: '--',
        fanStatus: '--',
        pm1: '--',
        pm25: '--',
        pm10: '--',
        pm03Num: '--',
        pm05Num: '--',
        pm1Num: '--',
        pm25Num: '--',
        pm5Num: '--',
        pm10Num: '--'
      },
      opts: [
        {
          name: '相对湿度',
          unit: '%',
          prop: 'humidity'
        },
        {
          name: '温度',
          unit: '℃',
          prop: 'temperature'
        },
        {
          name: '风扇状态',
          prop: 'fanStatus',
          formatter: e => {
            const dict = {
              0: '停止',
              1: '1档',
              2: '2档',
              3: '3档'
            };

            return this.$t(dict[e]) || '--';
          }
        },
        {
          name: 'PM1.0',
          unit: 'ug/m³',
          prop: 'pm1'
        },
        {
          name: 'PM2.5',
          unit: 'ug/m³',
          prop: 'pm25'
        },
        {
          name: 'PM10',
          unit: 'ug/m³',
          prop: 'pm10'
        },
        {
          name: '大于0.3个数',
          unit: '个/0.1L',
          prop: 'pm03Num',
          unitNeedI18n: true
        },
        {
          name: '大于0.5个数',
          unit: '个/0.1L',
          prop: 'pm05Num',
          unitNeedI18n: true
        },
        {
          name: '大于1.0个数',
          unit: '个/0.1L',
          prop: 'pm1Num',
          unitNeedI18n: true
        },
        {
          name: '大于2.5个数',
          unit: '个/0.1L',
          prop: 'pm25Num',
          unitNeedI18n: true
        },
        {
          name: '大于5个数',
          unit: '个/0.1L',
          prop: 'pm5Num',
          unitNeedI18n: true
        },
        {
          name: '大于10个数',
          unit: '个/0.1L',
          prop: 'pm10Num',
          unitNeedI18n: true
        }
      ],
      charts: [],
      time: {},
      empty: false
    };
  },
  methods: {
    getDetail() {
      this.getHistoryDetailData(this.eventId)
        .then(res => {
          if (!isObject(res) || !isObject(res.data)) return;
          const { deviceData, deviceDatas } = res.data;
          if (!Array.isArray(deviceDatas)) return;
          this.setData(deviceData);
          let mod = null;
          const list = deviceDatas
            .map(e => {
              mod = this.getMN606Mod(e);
              if (!mod) return;
              return { sensorDataList: mod.sensorDataList, beginTime: e.beginTime };
            })
            .filter(e => isObject(e));
          this.$refs.chartWrap.setData(list, this.getMN606Mod(deviceData));
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getMN606Mod(res) {
      if (!res || !res.mods || !res.mods.mn606Mod) return null;
      return res.mods.mn606Mod;
    },
    setData(res) {
      try {
        const { status, model, charts } = this;
        const { runstate, state, mods, beginTime } = res;
        const { mn606Mod } = mods;
        if (!mn606Mod || !mn606Mod.sensorDataList) return;
        this.time.begin = beginTime;

        Object.assign(status, {
          runState: runstate,
          alarmStatus: state
        });

        Object.assign(model, {
          humidity: mn606Mod.humidity,
          temperature: mn606Mod.temp,
          fanStatus: mn606Mod.fanStatus,
          pm1: mn606Mod.pm1,
          pm25: mn606Mod.pm25,
          pm10: mn606Mod.pm10,
          pm03Num: mn606Mod.pm03Num,
          pm05Num: mn606Mod.pm05Num,
          pm1Num: mn606Mod.pm1Num,
          pm25Num: mn606Mod.pm25Num,
          pm5Num: mn606Mod.pm5Num,
          pm10Num: mn606Mod.pm10Num
        });

        charts.splice(0, Infinity, ...mn606Mod.sensorDataList);
        this.empty = false;
      } catch (err) {
        console.error('[MN606][MONITRO][update error]', err);
      }
    },
    updateData(res) {
      if (!this.isHisDetail) this.setData(res);
    },
    enableMock() {
      this.hideLoading();
      this.hideInitNotice();
      this.hideTimeoutNotice();

      let num = 1;
      this.mockTimer = setInterval(() => {
        this.updateData(makeData(num++));
      }, 2000);
    },
    enableNetworkMock() {
      useKeyLongPressEvent({
        handler: key => {
          if ([1, 2, 3].includes(+key)) {
            this.status.networkMode = +key;
          }
        }
      });
    }
  },
  mounted() {
    // this.enableMock();
    // this.enableNetworkMock();

    if (!this.isHisDetail) return;
    this.$nextTick(() => {
      this.getDetail();
    });
  },
  beforeDestroy() {
    clearInterval(this.mockTimer);
  }
};
</script>

<style lang="scss">
.mn-606-container {
  width: 100%;
  height: 100%;

  span {
    @include state-textstyle;
  }

  .hint {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .common-border2 {
    border: 1px solid rgb(96, 118, 173);
  }

  .common-border {
    height: 100%;
    padding: 2px;
    background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
      url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
      url('~@/assets/image/linelight.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: top left, top right, bottom left, bottom right, center -5px;

    .comp3-content {
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
